var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17",
    "data-name": "Group 17",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.943,
    height: 190.943,
    viewBox: "0 0 190.943 190.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(45.337 23.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M261.714,66.441a7.2,7.2,0,0,0-10.176-.012l-86.332,86.1L134.058,118.7a7.2,7.2,0,0,0-10.588,9.749l36.222,39.338a7.188,7.188,0,0,0,5.141,2.32c.053,0,.1,0,.154,0a7.2,7.2,0,0,0,5.08-2.1L261.7,76.619A7.2,7.2,0,0,0,261.714,66.441Z",
    transform: "translate(-121.568 -64.327)",
    fill: "#00d672"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M183.746,88.275a7.2,7.2,0,0,0-7.2,7.2A81.079,81.079,0,1,1,95.471,14.393,7.2,7.2,0,1,0,95.471,0a95.471,95.471,0,1,0,95.471,95.471A7.2,7.2,0,0,0,183.746,88.275Z",
    fill: "#00d672"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenIcon);
export default __webpack_public_path__ + "static/media/check-green-icon.21420e360094a3bc6ac91d0e5e89a10c.svg";
export { ForwardRef as ReactComponent };